export type AppTextFont = "system" | "serif" | "rounded" | "mono";

export const TEXT_SCALE_MIN = 0.85;
export const TEXT_SCALE_MAX = 1.25;
export const TEXT_SCALE_DEFAULT = 1;

export const TEXT_FONTS: AppTextFont[] = ["system", "rounded", "serif", "mono"];
export const TEXT_FONT_DEFAULT: AppTextFont = "system";

const FONT_STACKS: Record<AppTextFont, string> = {
  system: "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Inter, sans-serif",
  rounded: "ui-rounded, 'SF Pro Rounded', 'Segoe UI Rounded', 'Nunito', system-ui, sans-serif",
  serif: "Georgia, 'Times New Roman', ui-serif, serif",
  mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
};

export function isAppTextFont(value: unknown): value is AppTextFont {
  return TEXT_FONTS.includes(value as AppTextFont);
}

export function fontStack(font: AppTextFont): string {
  return FONT_STACKS[font] ?? FONT_STACKS[TEXT_FONT_DEFAULT];
}

export function clampTextScale(raw: unknown): number {
  const n = typeof raw === "string" ? Number(raw) : typeof raw === "number" ? raw : NaN;
  if (!Number.isFinite(n)) return TEXT_SCALE_DEFAULT;
  return Math.min(TEXT_SCALE_MAX, Math.max(TEXT_SCALE_MIN, Math.round(n * 100) / 100));
}
